import styled from "styled-components";

export const Wrapper = styled.div`
  padding:10px 16px ;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
   }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`
export const TopMobile = styled.div`
  width: 100%;
  display: grid;
  gap: 48px;
  justify-items: center;

  @media (min-width: 1000px) {
    display: none;
  }

  img{
    width: 149px;
  }
`;

/* Marca (logo) com fallback em CSS se não houver svg/png */
export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;


  ${({ desktop }) => desktop && `
    display:none;
    @media (min-width:920px){ 
      display:flex; 
      .logo-mark{ width:24px; height:24px; }
      .logo-text{ font-size:18px; }
    }
  `}
`;

export const Socials = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const GridDesk = styled.div`
  display: none;
  @media (min-width: 1000px) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
  }

  img{
    width: 191px; 
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  P{
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  line-height: 2;
  }
`;

export const NavRow = styled.div`
  display: flex;
  display: flex;
  gap: 64px;

  a {
    font-weight: 600;
    font-style: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    color:var(--color-a786f6);
    text-align:left;
  }

`;



export const SubLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;

  a {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    text-align:left;
    color:var(--color-ffffff);
  }
`;

export const Copybar = styled.div`
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color:var(--color-8b8b8b)
`;
